import { FC, useContext } from "react";

import { SubmitButton, UseFormReturn, Form } from "capitalrx-components-2.0/lib/forms";
import { Button } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";

import { ProviderManagement } from "@/api/interfaces";
import { StatusFormBlock, PROVIDER_MANAGEMENT_LAYOUT } from "@/constants";
import { ThemeSelectorContext } from "@/context";
import { getThemeButton } from "@/utils";

import { DetailsGroupFields, ProviderDetailsDataForm } from "./DetailsGroupFields";

export interface DetailsFormProps {
  readonly onCancel: () => void;
  readonly onSubmit: (data: ProviderDetailsDataForm) => Promise<void>;
  readonly type: StatusFormBlock;
  readonly provider: ProviderManagement.ProviderSchema;
  readonly documents: ProviderManagement.DocumentSchema[];
  readonly form?: UseFormReturn<ProviderDetailsDataForm>;
  readonly isLoading?: boolean;
  readonly onEdit: () => void;
}

export const DetailsForm: FC<DetailsFormProps> = ({ onCancel, onSubmit, type, form, provider, documents, onEdit }) => {
  const { isCompressed } = useResponsive(PROVIDER_MANAGEMENT_LAYOUT);
  const ButtonGroup = isCompressed ? Stack : Shelf;

  const readOnly = type === "complete";
  const { primary_color } = useContext(ThemeSelectorContext);

  return (
    <Form form={form} onSubmit={onSubmit}>
      <Stack spacing="large">
        <DetailsGroupFields readOnly={readOnly} provider={provider} documents={documents} onEdit={onEdit} />
        {type === "edit" && (
          <Stack alignment={isCompressed ? "span" : "left"}>
            <ButtonGroup spacing="small">
              <SubmitButton appearance={getThemeButton("primary", primary_color)} testId="edit_provider_details_form_submit_button">Save</SubmitButton>
              <Button
                appearance={getThemeButton("secondary", primary_color)}
                onClick={onCancel}
                testId="edit_provider_details_form_clear_fields_button"
              >
                Discard Changes
              </Button>
            </ButtonGroup>
          </Stack>
        )}
      </Stack>
    </Form>
  );
};
